import React from "react";
import { useState, useEffect } from "react";

const GradientHeader = ({ logoSrc, justifyContent, showGradient, headerColor }) => {
  const [imgError, setImgError] = useState(false);
  const [logoStyle, setLogoStyle] = useState({
    height: "auto",
    width: "auto",
    maxWidth: "144px",
    maxHeight: "92px",
    objectFit: "contain",
    marginRight: "0px",
  });

  const checkLogoVisibility = (src, error) => {
    const defaultSwageazyLogo =
      "http://content.swageazy.com/website/logo-white-2_1767096866117.png";
    return (
      src &&
      src !== "" &&
      src !== "null" &&
      src !== defaultSwageazyLogo &&
      !error
    );
  };

  const handleImageLoad = (e) => {
    const img = e.target;
    const { naturalWidth, naturalHeight } = img;
    if (!naturalWidth || !naturalHeight) return;

    const aspectRatio = naturalWidth / naturalHeight;
    const viewportWidth = window.innerWidth;

    let targetWidth = 144;
    let maxHeight = 92;
    let squareMaxHeight = 52;

    if (viewportWidth >= 1920) {
      targetWidth = 170;
      maxHeight = 104;
      squareMaxHeight = 56;
    } else if (viewportWidth >= 1440) {
      targetWidth = 156;
      maxHeight = 98;
      squareMaxHeight = 54;
    } else if (viewportWidth >= 1024) {
      targetWidth = 144;
      maxHeight = 92;
      squareMaxHeight = 52;
    } else if (viewportWidth >= 768) {
      targetWidth = 118;
      maxHeight = 82;
      squareMaxHeight = 48;
    } else if (viewportWidth >= 576) {
      targetWidth = 118;
      maxHeight = 82;
      squareMaxHeight = 48;
    } else {
      targetWidth = 98;
      maxHeight = 70;
      squareMaxHeight = 40;
    }

    // Square and tall logos use a tighter height cap so they don't dominate the header
    if (aspectRatio <= 1.25) {
      maxHeight = squareMaxHeight;
    }

    let width = targetWidth;
    let height = width / aspectRatio;

    if (height > maxHeight) {
      height = maxHeight;
      width = height * aspectRatio;
    }

    setLogoStyle((prev) => ({
      ...prev,
      width: `${width}px`,
      height: `${height}px`,
      maxWidth: `${targetWidth}px`,
      maxHeight: `${maxHeight}px`,
    }));
  };

  // Add resize listener
  useEffect(() => {
    const handleResize = () => {
      // Trigger handleImageLoad again on resize
      const img = document.querySelector(".theme-logo-image");
      if (img) {
        handleImageLoad({ target: img });
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!checkLogoVisibility(logoSrc, imgError)) return null;

  const defaultColor = "#1E1665";
  const resolvedHeaderColor = headerColor || defaultColor;
  const isRightAligned = ["flex-end", "end", "right"].includes(justifyContent);

  return (
    <div
      style={{
        width: "100%",
        paddingTop: "12px",
        paddingBottom: "12px",
        background: showGradient
        ? `linear-gradient(
            to bottom,
            ${resolvedHeaderColor} 0%,
            rgba(58,94,255,0) 100%
          )`
        : "transparent",
        display: "flex",
        justifyContent: justifyContent || "flex-start",
        alignItems: "center",
        minHeight: "72px",
        boxSizing: "border-box",
        // Pad both sides so the logo never touches the screen edge, whichever side it sits on
        paddingLeft: "28px",
        paddingRight: "28px",
      }}
    >
      <img
        className="img-fluid theme-logo-image"
        src={logoSrc}
        alt="Logo"
        // Mirror the stylesheet's 15px left margin when the logo is right-aligned
        style={
          isRightAligned
            ? { ...logoStyle, marginLeft: "0px", marginRight: "15px" }
            : logoStyle
        }
        onError={() => setImgError(true)}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default GradientHeader;
